// Author Pan Yu Rou
// Date 2024-12-20 15:09:47

class SithMesPrdZpp2 {
constructor({
        id = null,
        usage = '',
        machineType = '',
        number = '',
        orderCodeDescription = '',
        projectCode = '',
        costCenterCategory = '',
        costCenter = '',
        wbsCode = '',
        groupNumber = '',
        status = '',
        orderCode = '',
        workOrderCode = '',
        needUploadAttachment = '',
        remark = ''}
= {}) {
    this.id = id;
    this.usage = usage;
    this.machineType = machineType;
    this.number = number;
    this.orderCodeDescription = orderCodeDescription;
    this.projectCode = projectCode;
    this.costCenterCategory = costCenterCategory;
    this.costCenter = costCenter;
    this.wbsCode = wbsCode;
    this.groupNumber = groupNumber;
    this.status = status;
    this.orderCode = orderCode;
    this.workOrderCode = workOrderCode;
    this.needUploadAttachment = needUploadAttachment;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesPrdZpp2();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.prd.sithMesPrdZpp2.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'usage',
        label: 'label.sith.prd.sithMesPrdZpp2.grid.usage',
        sortable: true,
        form: {
        type: 'dictEnumSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'zpp2_workflow_usage'
                        }
        },
        {
        key: 'machineType',
        label: 'label.sith.prd.sithMesPrdZpp2.grid.machineType',
        sortable: true,
        form: {
        type: 'dictEnumSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'zpp2_workflow_machine_type'
                        }
        },
        {
        key: 'number',
        label: 'label.sith.prd.sithMesPrdZpp2.grid.number',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'orderCodeDescription',
        label: 'label.sith.prd.sithMesPrdZpp2.grid.orderCodeDescription',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'projectCode',
        label: 'label.sith.prd.sithMesPrdZpp2.grid.projectCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'costCenterCategory',
        label: 'label.sith.prd.sithMesPrdZpp2.grid.costCenterCategory',
        sortable: true,
        form: {
        type: 'dictEnumSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'zpp2_workflow_costCenter_category'
                        }
        },
        {
        key: 'costCenter',
        label: 'label.sith.prd.sithMesPrdZpp2.grid.costCenter',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'wbsCode',
        label: 'label.sith.prd.sithMesPrdZpp2.grid.wbsCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'groupNumber',
        label: 'label.sith.prd.sithMesPrdZpp2.grid.groupNumber',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'orderCode',
        label: 'label.sith.prd.sithMesPrdZpp2.grid.orderCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'status',
        label: 'label.sith.prd.sithMesPrdZpp2.grid.status',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'workOrderCode',
        label: 'label.sith.prd.sithMesPrdZpp2.grid.workOrderCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'orderCodeCreatorName',
        label: 'label.sith.prd.sithMesPrdZpp2.grid.orderCodeCreatorName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'orderCodeCreateTime',
        label: 'label.sith.prd.sithMesPrdZpp2.grid.orderCodeCreateTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'graphicTechnicianName',
        label: 'label.sith.prd.sithMesPrdZpp2.grid.graphicTechnicianName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'technicianDrawingTime',
        label: 'label.sith.prd.sithMesPrdZpp2.grid.technicianDrawingTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'orderCodeResolverName',
        label: 'label.sith.prd.sithMesPrdZpp2.grid.orderCodeResolverName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'orderCodeResolvedTime',
        label: 'label.sith.prd.sithMesPrdZpp2.grid.orderCodeResolvedTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdZpp2.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'createdTime',
        label: 'label.sith.prd.sithMesPrdZpp2.grid.createdTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'createdByName',
        label: 'label.sith.prd.sithMesPrdZpp2.grid.createdByName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'statusName',
        label: 'label.sith.prd.sithMesPrdZpp2.grid.statusName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    usageFilter : '',
    machineTypeFilter : '',
    numberFilter : '',
    orderCodeDescriptionFilter : '',
    projectCodeFilter : '',
    costCenterCategoryFilter : '',
    costCenterFilter : '',
    wbsCodeFilter : '',
    groupNumberFilter : '',
    orderCodeFilter : '',
    statusFilter : '',
    workOrderCodeFilter : '',
    orderCodeCreatorFilter : '',
    createdByNameFilter : '',
    createdTimeRteFilter : '',
    createdTimeLteFilter : '',
    orderCodeCreateTimeRteFilter : '',
    orderCodeCreateTimeLteFilter : '',
    graphicTechnicianFilter : '',
    technicianDrawingTimeRteFilter : '',
    technicianDrawingTimeLteFilter : '',
    orderCodeResolverFilter : '',
    orderCodeResolvedTimeRteFilter : '',
    orderCodeResolvedTimeLteFilter : '',
    workflowQueryTypeFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'usageFilter',
        label: 'label.sith.prd.sithMesPrdZpp2.filter.usage',
        disabled: false,
        form: {
        type: 'dictEnumSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'zpp2_workflow_usage'
                }
        },
        {
        key: 'machineTypeFilter',
        label: 'label.sith.prd.sithMesPrdZpp2.filter.machineType',
        disabled: false,
        form: {
        type: 'dictEnumSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'zpp2_workflow_machine_type'
                }
        },
        {
        key: 'numberFilter',
        label: 'label.sith.prd.sithMesPrdZpp2.filter.number',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'orderCodeDescriptionFilter',
        label: 'label.sith.prd.sithMesPrdZpp2.filter.orderCodeDescription',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'projectCodeFilter',
        label: 'label.sith.prd.sithMesPrdZpp2.filter.projectCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'costCenterCategoryFilter',
        label: 'label.sith.prd.sithMesPrdZpp2.filter.costCenterCategory',
        disabled: false,
        form: {
        type: 'dictEnumSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'zpp2_workflow_costCenter_category'
                }
        },
        {
        key: 'costCenterFilter',
        label: 'label.sith.prd.sithMesPrdZpp2.filter.costCenter',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'wbsCodeFilter',
        label: 'label.sith.prd.sithMesPrdZpp2.filter.wbsCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'groupNumberFilter',
        label: 'label.sith.prd.sithMesPrdZpp2.filter.groupNumber',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'orderCodeFilter',
        label: 'label.sith.prd.sithMesPrdZpp2.filter.orderCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'statusFilter',
        label: 'label.sith.prd.sithMesPrdZpp2.filter.status',
        disabled: false,
        form: {
        type: 'entitySelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emActProcessStatus'
            ,showLabelSelectOne: true
                    ,selectFilter:{processBusinessEntityFilter:'SithMesPrdZpp2',statusFilter:1}
        }
        },
        {
        key: 'workOrderCodeFilter',
        label: 'label.sith.prd.sithMesPrdZpp2.filter.workOrderCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'orderCodeCreatorFilter',
        label: 'label.sith.prd.sithMesPrdZpp2.filter.orderCodeCreator',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'createdByNameFilter',
        label: 'label.sith.prd.sithMesPrdZpp2.filter.createdByName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'createdTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdZpp2.filter.createdTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'createdTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdZpp2.filter.createdTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'orderCodeCreateTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdZpp2.filter.orderCodeCreateTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'orderCodeCreateTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdZpp2.filter.orderCodeCreateTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'graphicTechnicianFilter',
        label: 'label.sith.prd.sithMesPrdZpp2.filter.graphicTechnician',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'technicianDrawingTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdZpp2.filter.technicianDrawingTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'technicianDrawingTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdZpp2.filter.technicianDrawingTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'orderCodeResolverFilter',
        label: 'label.sith.prd.sithMesPrdZpp2.filter.orderCodeResolver',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'orderCodeResolvedTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdZpp2.filter.orderCodeResolvedTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'orderCodeResolvedTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdZpp2.filter.orderCodeResolvedTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
];


    const entityFormConfigs = [
        {
        key: 'usage',
        label: 'label.sith.prd.sithMesPrdZpp2.entity.usage',
        sortable: true,
        disabled: false,
        form: {
        type: 'dictEnumSelect',
        modalMultiSelectedType: 'string'
            ,required: true
            ,entity: 'zpp2_workflow_usage'
                }
        },
        {
        key: 'machineType',
        label: 'label.sith.prd.sithMesPrdZpp2.entity.machineType',
        sortable: true,
        disabled: false,
        form: {
        type: 'dictEnumSelect',
        modalMultiSelectedType: 'string'
            ,required: true
            ,entity: 'zpp2_workflow_machine_type'
                }
        },
        {
        key: 'number',
        label: 'label.sith.prd.sithMesPrdZpp2.entity.number',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
            ,required: true
                }
        },
        {
        key: 'orderCodeDescription',
        label: 'label.sith.prd.sithMesPrdZpp2.entity.orderCodeDescription',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
            ,required: true
                }
        },
        {
        key: 'projectCode',
        label: 'label.sith.prd.sithMesPrdZpp2.entity.projectCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
            ,required: true
                }
        },
        {
        key: 'costCenterCategory',
        label: 'label.sith.prd.sithMesPrdZpp2.entity.costCenterCategory',
        sortable: true,
        disabled: false,
        form: {
        type: 'dictEnumSelect',
        modalMultiSelectedType: 'string'
            ,required: true
            ,entity: 'zpp2_workflow_costCenter_category'
                }
        },
        {
        key: 'costCenter',
        label: 'label.sith.prd.sithMesPrdZpp2.entity.costCenter',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
            ,required: true
                }
        },
        {
        key: 'wbsCode',
        label: 'label.sith.prd.sithMesPrdZpp2.entity.wbsCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
            ,required: true
                }
        },
        {
        key: 'groupNumber',
        label: 'label.sith.prd.sithMesPrdZpp2.entity.groupNumber',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
            ,required: true
                }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdZpp2.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        }
]

export {SithMesPrdZpp2, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
